import React, { useState } from "react";
import Column from "canvas-core-react/lib/Column";
import Row from "canvas-core-react/lib/Row";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import Card from "canvas-core-react/lib/Card";
import Margin from "canvas-core-react/lib/Margin";
import { CheckboxComponent } from "../checkbox";
import { ButtonOk } from "../buttonOk";

interface TitleCheckboxsProps {
  title: string;
  checkboxs: string[];
  id?: string;
  text?: string;
}

export const TitleCheckboxsComponent = ({
  title,
  checkboxs,
  id,
  text
}: TitleCheckboxsProps) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  return (
    <Card>
      <Margin xs={18} sm={18} md={18} lg={18} side="bottom">
        <Row>
          <Column xs={4} sm={8} md={12} lg={12}>
            <TextSubtitle component="span">{title}</TextSubtitle>
          </Column>
        </Row>
      </Margin>
      {checkboxs.map((value, index) => {
        return (
          <Row>
            <Column xs={4} sm={8} md={12} lg={12}>
              <CheckboxComponent id={index.toString()} text={value} />
            </Column>
          </Row>
        );
      })}
      <Margin xs={30} sm={30} md={30} lg={30}>
        <Row justifyContent="center">
          <Column xs={4} sm={8} md={12} lg={12}>
            <ButtonOk
              title="Continuar"
              onClick={() => setIsButtonDisabled(true)}
              disabled={isButtonDisabled}
              isLarge={true}
            />
          </Column>
        </Row>
      </Margin>
    </Card>
  );
};
